import React from "react";
import "../styles/footer.css";
// @ts-ignore
import githubIcon from "../assets/icons8-github.svg";
// @ts-ignore
import zhihuIcon from "../assets/zhihu_icon.svg";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import twitterIcon from "../assets/twitter_icon.svg";
import mailIcon from "../assets/mail.svg";
import buildingIcon from "../assets/building.svg";
import build from "../assets/build.png";
import clockIcon from "../assets/clock.svg";
import time from "../assets/time.png";
import email from "../assets/email.png";
export default function Footer() {
  const logoImg = require("../assets/Logo_transparent_bg.png") as string;
  const AMIImg = require("../assets/AMI_logo.png") as string;

  return (
    <footer>
      <div className="row footerMain" style={{width:'1400px',margin:'0 auto'}}>
        <div className="">
          <div className="logo-container">
            <a target="_blank" href={"https://personal.ntu.edu.sg/boan/"}>
              <img
                src={AMIImg}
                alt="brand-image"
                className="brand-image-footer"
              />
            </a>
            <i className="logo-title" style={{ fontSize: "20px" }}>
              <strong style={{ fontSize: "inherit" }}>Agent Mediated Intelligence</strong> Research Group
            </i>
          </div>
        </div>
        <div className="col" style={{ marginTop: "20px" }}>
          <div className="row info">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "24px",
                marginTop:'10px'
              }}
            >
            <img
                src={email}
                alt="github Icon"
                className="info-box-icon"
              />
              <i className="logo-title" style={{ fontSize: "16px" }}>
                <strong style={{ fontSize: "inherit" }}> TradeMaster.NTU@gmail.com</strong>
              </i>
             
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "24px",
                marginTop:'20px',
              }}
            >
              <img
                src={build}
                alt="github Icon"
                className="info-box-icon"
              />
              <i className="logo-title" style={{ fontSize: "16px" }}>
                <strong style={{ fontSize: "inherit" }}>ABN 03a-03/04/05, 61 Nanyang Drive Singapore 637335</strong>
              </i>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "24px",
                marginTop:'20px'
              }}
            >
              <img
                src={time}
                alt="github Icon"
                className="info-box-icon"
              />
               <i className="logo-title" style={{ fontSize: "16px" }}>
                <strong style={{ fontSize: "inherit" }}> 9am - 6pm</strong>
              </i>
            </div>
          </div>
          <div>
            <div className="icons-container" style={{ display: "flex" }}>
              <a
                href="https://github.com/TradeMaster-NTU/TradeMaster"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={githubIcon}
                  alt="github Icon"
                  className="icon"
                  style={{ width: "50px", height: "50px" }}
                />
              </a>
              <a
                href="https://www.zhihu.com/people/trademaster-22"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={zhihuIcon}
                  alt="zhihu icon"
                  className="icon"
                  style={{ width: "50px", height: "50px" }}
                />
              </a>
              <a
                href="https://twitter.com/NtuTrademaster"
                target="_blank"
                rel="noreferrer"
              >
                <img src={twitterIcon} alt="twitter icon" className="icon" style={{ width: "50px", height: "50px" }} />
              </a>

            </div>

            <div>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
